/**
 * Sri Lanka's 25 administrative districts — the agency's own market, used for
 * the client's home address and as a campaign filter ("everyone in Kurunegala").
 * If the agency operates elsewhere, this is the list to swap.
 */
export const DISTRICTS = [
  'Ampara',
  'Anuradhapura',
  'Badulla',
  'Batticaloa',
  'Colombo',
  'Galle',
  'Gampaha',
  'Hambantota',
  'Jaffna',
  'Kalutara',
  'Kandy',
  'Kegalle',
  'Kilinochchi',
  'Kurunegala',
  'Mannar',
  'Matale',
  'Matara',
  'Monaragala',
  'Mullaitivu',
  'Nuwara Eliya',
  'Polonnaruwa',
  'Puttalam',
  'Ratnapura',
  'Trincomalee',
  'Vavuniya',
] as const

export type District = (typeof DISTRICTS)[number]
